﻿function runCarousel(intervalsFromUmbraco) {
    let container = document.getElementById("slides");
    let slides = Array.from(document.querySelectorAll("#slides .slide"));
    if (!container || slides.length === 0) return;

    let images = slides.map(s => s.querySelector("img")).filter(Boolean);
    if (images.length === 0) return;

    function onImageReady(img) {
        return new Promise(resolve => {
            if (img.complete && img.naturalWidth > 0) resolve();
            else img.addEventListener("load", resolve, { once: true });
        });
    }

    (async function init() {
        let firstImg = images[0];
        await onImageReady(firstImg);

        let refWidth = firstImg.offsetWidth || firstImg.naturalWidth || 0;
        let refHeight = firstImg.offsetHeight || firstImg.naturalHeight || 0;

        if (!refWidth || !refHeight) return;

        container.style.position = "relative";
        container.style.height = refHeight + "px";
        container.style.overflow = "hidden";

        slides.forEach((s, idx) => {
            s.style.position = "absolute";
            s.style.inset = "0";
            s.style.transition = "opacity 0.6s ease";
            s.style.opacity = idx === 0 ? "1" : "0";
            s.style.display = idx === 0 ? "block" : "none";
            s.style.pointerEvents = idx === 0 ? "auto" : "none";
        });

        images.forEach((img, idx) => {
            img.style.width = refWidth + "px";
            img.style.height = refHeight + "px";

            img.style.objectFit = "cover";

            img.style.display = "block";
            img.style.margin = "0 auto";
        });

        slides.forEach(s => {
            s.style.display = s.style.display || "none";
            s.style.width = refWidth + "px";
            s.style.height = refHeight + "px";
            s.style.margin = "0 auto";
        });

        let current = 0;
        function showSlide(next) {
            if (next === current) return;
            let prevEl = slides[current];
            let nextEl = slides[next];

            nextEl.style.display = "block";
            nextEl.style.pointerEvents = "auto";
            nextEl.style.opacity = "0";

            nextEl.getBoundingClientRect();

            prevEl.style.opacity = "0";
            nextEl.style.opacity = "1";

            let durationMs = 600;
            setTimeout(() => {
                prevEl.style.display = "none";
                prevEl.style.pointerEvents = "none";
            }, durationMs);

            current = next;
        }

        setInterval(() => {
            let next = (current + 1) % slides.length;
            showSlide(next);
        }, intervalsFromUmbraco);
    })();
}